import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth, signOut } from '../lib/auth';

export default function Layout() {
  const { user, isAdmin } = useAuth();
  const location = useLocation();

  const navItem =
    'px-3 py-2 rounded text-sm font-medium hover:bg-white/10 transition-colors';
  const navItemActive = 'bg-white/15';

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-navy text-white">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-4">
          <Link to="/" className="font-bold text-lg">
            Hängestens Båtförening
          </Link>
          {user && (
            <nav className="flex-1 flex items-center gap-1">
              <NavLink
                to="/mina-batar"
                className={({ isActive }) =>
                  `${navItem} ${isActive ? navItemActive : ''}`
                }
              >
                Mina båtar
              </NavLink>
              <NavLink
                to="/profil"
                className={({ isActive }) =>
                  `${navItem} ${isActive ? navItemActive : ''}`
                }
              >
                Profil
              </NavLink>
              {isAdmin && (
                <NavLink
                  to="/admin"
                  className={({ isActive }) =>
                    `${navItem} ${isActive ? navItemActive : ''}`
                  }
                >
                  Admin
                </NavLink>
              )}
            </nav>
          )}
          {user && (
            <button
              type="button"
              onClick={() => void signOut()}
              className="text-sm underline"
            >
              Logga ut
            </button>
          )}
        </div>
      </header>
      {user && isAdmin && location.pathname.startsWith('/admin') && (
        <div className="bg-navy/85 text-white">
          <div className="max-w-5xl mx-auto px-4 py-2 flex gap-1 text-sm">
            <NavLink
              to="/admin/medlemmar"
              className={({ isActive }) =>
                `${navItem} ${isActive ? navItemActive : ''}`
              }
            >
              Medlemmar
            </NavLink>
            <NavLink
              to="/admin/batplatser"
              className={({ isActive }) =>
                `${navItem} ${isActive ? navItemActive : ''}`
              }
            >
              Båtplatser
            </NavLink>
            <NavLink
              to="/admin/admins"
              className={({ isActive }) =>
                `${navItem} ${isActive ? navItemActive : ''}`
              }
            >
              Admins
            </NavLink>
          </div>
        </div>
      )}
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 py-6">
        <Outlet />
      </main>
      <footer className="text-center text-xs text-gray-500 py-4">
        © Hängestens Båtförening
      </footer>
    </div>
  );
}
